var permissionCheckUtil = {};

permissionCheckUtil.findName = function(permission){
  var permissions = JSON.parse(localStorage.getItem('permissions'));


  let per = permissions.find(item=>item===permission)?true:false;

  // alert(permissions.find(item=>item===permission))
  // alert(per)

  return per;
}

export { permissionCheckUtil}




// WEBPACK FOOTER //
// ./src/utils/permission.js